// extracted by mini-css-extract-plugin
export default {"container":"content_container__N-AjQ","form":"content_form__aaMXc"};